import { render, staticRenderFns } from "./DesignThumbnail.vue?vue&type=template&id=5fcb3f22&scoped=true&"
import script from "./DesignThumbnail.vue?vue&type=script&lang=js&"
export * from "./DesignThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./DesignThumbnail.vue?vue&type=style&index=0&id=5fcb3f22&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcb3f22",
  null
  
)

export default component.exports